<div data-testid="after-audit-header" class="p-6">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3">
    {{ 'after.audit.title' | translate }}
  </h2>
</div>
<router-outlet data-testid="after-audit-router-outlet"></router-outlet>
